/* Google Analytics tag */
export default function gtag() {
  window.dataLayer = window.dataLayer || [];
  if (window.dataLayer) window.dataLayer.push(arguments);
}
